import { Link } from 'react-router-dom';

const steps = [
  {
    number: '01',
    title: 'Choose Your Experience',
    description: 'Browse art classes, party packages, or themed events. Pick the experience that excites you — kids, adults, or a private group.',
    icon: 'ri-search-eye-line',
    accentColor: '#ff4322',
  },
  {
    number: '02',
    title: 'Reserve Your Spot',
    description: 'Book online in minutes via the studio calendar. Secure your date and get instant confirmation. We handle the rest.',
    icon: 'ri-calendar-check-line',
    accentColor: '#ffb300',
  },
  {
    number: '03',
    title: 'Arrive & Create',
    description: 'Walk in with nothing but your energy. All supplies are set up. Kelsey guides every step in a relaxed, fun atmosphere.',
    icon: 'ri-brush-4-line',
    accentColor: '#ff7120',
  },
  {
    number: '04',
    title: 'Leave With Art + Memories',
    description: 'Take home your finished original artwork. And memories that last far longer than the canvas.',
    icon: 'ri-heart-3-line',
    accentColor: '#e0285a',
  },
];

const Process = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden" style={{ background: '#080808' }}>
      {/* Background texture */}
      <div className="absolute inset-0 pointer-events-none opacity-30"
        style={{ backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E\")", backgroundSize: '200px 200px' }}
      />

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-end mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-artden-coral" />
              <span className="section-label">How It Works</span>
            </div>
            <h2 className="font-cormorant font-medium text-white leading-[1.0] tracking-tight" style={{ fontSize: 'clamp(2.5rem, 5vw, 4.5rem)' }}>
              Your Creative<br />
              <em className="font-light italic" style={{ color: '#ffb300' }}>Journey Starts Here</em>
            </h2>
          </div>
          <p className="font-outfit text-artden-muted text-base leading-relaxed">
            From browsing the calendar to walking out with your masterpiece — the process is simple, guided, and genuinely fun.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 rounded-2xl overflow-hidden">
          {steps.map((step, i) => (
            <div
              key={i}
              className="relative p-8 group transition-all duration-300 hover:bg-white/5"
              style={{ background: '#0e0e0e' }}
            >
              {/* Large number background */}
              <div
                className="absolute -top-2 right-5 font-cormorant font-bold text-[100px] leading-none select-none pointer-events-none transition-opacity duration-300 opacity-8 group-hover:opacity-15"
                style={{ color: step.accentColor }}
              >
                {step.number}
              </div>

              {/* Icon */}
              <div
                className="relative z-10 w-12 h-12 flex items-center justify-center rounded-xl mb-6 transition-all duration-300 group-hover:scale-110"
                style={{ background: `${step.accentColor}18`, border: `1px solid ${step.accentColor}30` }}
              >
                <i className={`${step.icon} text-xl`} style={{ color: step.accentColor }}></i>
              </div>

              {/* Step badge */}
              <span
                className="relative z-10 inline-block font-outfit text-xs font-bold tracking-widest2 uppercase mb-4"
                style={{ color: step.accentColor }}
              >
                Step {step.number}
              </span>

              <h3 className="relative z-10 font-cormorant text-2xl font-semibold text-white mb-3 leading-tight">
                {step.title}
              </h3>
              <p className="relative z-10 font-outfit text-artden-muted text-sm leading-relaxed">
                {step.description}
              </p>

              {/* Connector line (not on last) */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-px w-px h-12 -translate-y-1/2" style={{ background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.1), transparent)' }} />
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://artdenstudio.com/calendar/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-artden-coral hover:brightness-110 text-white font-semibold px-8 py-4 rounded-full transition-all inline-flex items-center gap-2.5 whitespace-nowrap"
          >
            Book Your Class
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
          <Link
            to="/parties-events"
            className="border border-white/15 hover:border-artden-amber text-white/70 hover:text-artden-amber font-semibold px-8 py-4 rounded-full transition-all inline-flex items-center gap-2.5 whitespace-nowrap"
          >
            Plan Your Party
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-cake-3-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Process;
